"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var root_1 = require("react-hot-loader/root");
var react_router_dom_1 = require("react-router-dom");
var NavBar_1 = __importDefault(require("./NavBar"));
var InternalApp = function (_a) {
    var appTitle = _a.appTitle, children = _a.children, userName = _a.userName, logoutUrl = _a.logoutUrl, links = _a.links;
    return (React.createElement(react_router_dom_1.BrowserRouter, { basename: '/' },
        React.createElement(NavBar_1["default"], { title: appTitle, userName: userName, logoutUrl: logoutUrl, links: links }),
        React.createElement(react_router_dom_1.Switch, null,
            children,
            React.createElement(react_router_dom_1.Redirect, { to: "/" }))));
};
InternalApp.defaultProps = {
    appTitle: 'Admin',
    children: React.createElement("div", null),
    userName: '',
    logoutUrl: '/logout'
};
exports["default"] = root_1.hot(InternalApp);
